import { Portal } from '@radix-ui/react-dialog'
import type { ComponentProps } from 'react'

type PortalProps = ComponentProps<typeof Portal>

export interface DialogPortalProps extends PortalProps {
  forceMount?: PortalProps['forceMount']
  container?: PortalProps['container']
  children?: PortalProps['children']
}

export const DialogPortal = Portal
